// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "计算机系统",
      "tec": "才九荣",
      "week": "6-16周",
      "add": "实训楼F座608信机"
    },
    [
      {
        "sub": "交际口语1",
        "tec": "外教6",
        "week": "6-18周",
        "add": "电2"
      },
      {
        "sub": "104国教",
        "tec": "外教9",
        "week": "6-18周",
        "add": "电2"
      },
      {
        "sub": "105国教",
        "tec": "外教8",
        "week": "6-18周",
        "add": "电2"
      },
      {
        "sub": "106国教",
        "tec": "外教7",
        "week": "6-18周",
        "add": "电2"
      }
    ],
    {
      "sub": "高等数学",
      "tec": "刘晓静",
      "week": "6-19周",
      "add": "教学楼A座326电力"
    },
    0,
    0
  ],
  "2": [
    {
      "sub": "人工智能与计算机应用软件",
      "tec": "徐立波",
      "week": "6-17周",
      "add": "实训楼C座108"
    },
    {
      "sub": "电路（上）",
      "tec": "吴金玲",
      "week": "6-18周",
      "add": "502国教"
    },
    [
      {
        "sub": "综合英语1",
        "tec": "于轶",
        "week": "6-18周",
        "add": "电7"
      },
      {
        "sub": "109国教",
        "tec": "张珺莹",
        "week": "6-18周",
        "add": "电7"
      },
      {
        "sub": "107国教",
        "tec": "张煜",
        "week": "6-18周",
        "add": "电7"
      },
      {
        "sub": "404国教",
        "tec": "孙琪",
        "week": "6-18周",
        "add": "电7"
      },
      {
        "sub": "106国教",
        "tec": "程子凌",
        "week": "6-18周",
        "add": "电7"
      },
      {
        "sub": "104国教",
        "tec": "赵允鹏",
        "week": "6-18周",
        "add": "电7"
      },
      {
        "sub": "103国教",
        "tec": "冯威",
        "week": "6-18周",
        "add": "电7"
      },
      {
        "sub": "320国教",
        "tec": "KONG MI",
        "week": "6-18周",
        "add": "电7"
      }
    ],
    {
      "sub": "体育",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[07-08节]）"
    },
    {
      "sub": "形势与政策",
      "tec": "王姝",
      "week": "6-9周",
      "add": "教学楼C座311教务"
    }
  ],
  "3": [
    {
      "sub": "高等数学",
      "tec": "刘晓静",
      "week": "6-19周",
      "add": "教学楼A座226电力"
    },
    {
      "sub": "计算机系统",
      "tec": "才九荣",
      "week": "6-16周",
      "add": "实训楼F座608信机"
    },
    0,
    0,
    0
  ],
  "4": [
    [
      {
        "sub": "综合英语1",
        "tec": "赵允鹏",
        "week": "6-18周",
        "add": "电6"
      },
      {
        "sub": "103国教",
        "tec": "程子凌",
        "week": "6-18周",
        "add": "电6"
      },
      {
        "sub": "104国教",
        "tec": "孙琪",
        "week": "6-18周",
        "add": "电6"
      },
      {
        "sub": "106国教",
        "tec": "张珺莹",
        "week": "6-18周",
        "add": "电6"
      },
      {
        "sub": "107国教",
        "tec": "KONG MI",
        "week": "6-18周",
        "add": "电6"
      },
      {
        "sub": "108国教",
        "tec": "于轶",
        "week": "6-18周",
        "add": "电6"
      },
      {
        "sub": "109国教",
        "tec": "冯威",
        "week": "6-18周",
        "add": "电6"
      },
      {
        "sub": "320国教",
        "tec": "张煜",
        "week": "6-18周",
        "add": "电6"
      }
    ],
    {
      "sub": "人工智能与计算机应用软件",
      "tec": "徐立波",
      "week": "6-17周",
      "add": "实训楼C座108"
    },
    {
      "sub": "电路（上）",
      "tec": "吴金玲",
      "week": "6-18周",
      "add": "502国教"
    },
    {
      "sub": "就业创业指导",
      "tec": "于瑶",
      "week": "6-10周",
      "add": "教学楼D座326文法"
    },
    {
      "sub": "军事理论",
      "tec": "于瑶",
      "week": "6-13,15周",
      "add": "教学楼D座326文法"
    }
  ],
  "5": [
    [
      {
        "sub": "交际口语1",
        "tec": "外教6",
        "week": "6-18周",
        "add": "电6"
      },
      {
        "sub": "104国教",
        "tec": "外教9",
        "week": "6-18周",
        "add": "电6"
      },
      {
        "sub": "105国教",
        "tec": "外教8",
        "week": "6-18周",
        "add": "电6"
      },
      {
        "sub": "106国教",
        "tec": "外教7",
        "week": "6-18周",
        "add": "电6"
      }
    ],
    {
      "sub": "心理健康与调适",
      "tec": "崔雅欣",
      "week": "6-15周",
      "add": "教学楼B座224自控"
    },
    {
      "sub": "高等数学",
      "tec": "刘晓静",
      "week": "6-19周",
      "add": "教学楼A座425机械"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
